import React from "react";
import ReactDOM from "react-dom";
import BemovedApplication from "./src/index.jsx";

const element = document.querySelector("#bemoved-web");

ReactDOM.render(<BemovedApplication />, element);
